export default __webpack_public_path__ + "50a75040d34b95a568756e4b5566b951.svg";